
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import mycommon from "./plugins/mycommon";

Vue.prototype.$mycommon = mycommon;


Vue.config.productionTip = false


// router.afterEach((to,from, next) => {
//   window.scrollTo(0,0)
// })

export const apiprefix="";

Vue.directive('title',{
  inserted: function(el){
    document.title = el.getAttribute('title')
  }
})
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
